// @flow

import {RoleTypes} from "./Role";
import type {Role} from "./Role";

export const SALE_MARKER = "SALE";
// the distributor module compares the price with the RRP only, not with the 30-day minimum (#56869)
export const BELOW_RRP_MARKER = "BELOW-RRP";

const OFFER_MARKERS = [SALE_MARKER, BELOW_RRP_MARKER];

export const offerMarkerFor = (role: ?Role): string =>
    role === RoleTypes.DISTRIBUTOR ? BELOW_RRP_MARKER : SALE_MARKER;

export const offerCategoryKeyFor = (role: ?Role): string => "_" + offerMarkerFor(role);

// either route opens the offers of the module, so a shared link works in both
export const isOfferCategory = (category: ?string): boolean =>
    OFFER_MARKERS.includes((category || "").replace(/^_/, ""));

export const includesOfferMarker = (markers: ?Array<string>): boolean =>
    (markers || []).some(marker => OFFER_MARKERS.includes(marker));
